import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { CONSTANTS } from '../../constants'
import { baseQueryConfigured } from '../../plugins/rtk-query.config'
import {
  CreateRatingSurveyRequestPayload,
  Rating,
  SaveRatingRequestPayload,
} from '../../types'

export type GetRatingsQueryPaylod = {
  user_id?: string
  limit?: string
  value?: string
}

export const ratingsApi = createApi({
  reducerPath: 'ratingsApi',
  baseQuery: baseQueryConfigured,
  tagTypes: ['Ratings'],
  endpoints: (builder) => ({
    getRatings: builder.query<Rating[], GetRatingsQueryPaylod>({
      query: (query: GetRatingsQueryPaylod) => ({
        url: generateUrl(query),
      }),
      providesTags: ['Ratings'],
    }),
    saveRatingSurvey: builder.mutation({
      query: (payload: CreateRatingSurveyRequestPayload) => {
        return {
          url: `${CONSTANTS.API.RATINGS}/${payload.rating_id}${CONSTANTS.API.SURVEYS}`,
          method: 'POST',
          body: payload,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      },
    }),
    saveRating: builder.mutation({
      query: (payload: SaveRatingRequestPayload) => {
        return {
          url: `${CONSTANTS.API.RATINGS}`,
          method: 'POST',
          body: payload,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      },
      invalidatesTags: ['Ratings'],
    }),
  }),
})

const generateUrl = (queryParams: GetRatingsQueryPaylod) => {
  let query = new URLSearchParams(queryParams).toString()
  query = query.replace('undefined', '')
  return `${CONSTANTS.API.RATINGS}${query.length > 0 ? '?' : ''}${query}`
}

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetRatingsQuery,
  useSaveRatingSurveyMutation,
  useSaveRatingMutation,
} = ratingsApi
